export interface State {
    name: string;
    code: string;
}
export interface Country {
    name: string;
    code: string;
    states: State[];
}

let _countries: Country[];

export async function getCountryList(): Promise<Country[]> {
    if (_countries) {
        return _countries;
    }
    _countries = [];
    const response = await fetch('/api/geo/countries');
    const payload = await response.json();
    _countries = payload.map((country: any) => {
        return {
            name: country.name,
            code: country.iso3,
            iso3: country.iso3,
            iso2: country.iso2,
            states: country.states.map((state: any) => {
                return {
                    name: state.name,
                    code: state.code || state.name
                }
            })
        }
    });
    _countries.sort((a, b) => {
        if (a.code === 'USA') {
            return -1;
        }
        if (b.code === 'USA') {
            return 1;
        }
        if (a.code === 'CAN') {
            return -1;
        }
        if (b.code === 'CAN') {
            return 1;
        }
        return a.name.localeCompare(b.name);
    });
    return _countries;
}

export async function getCountry(code:string): Promise<Country> {
    const countries = await getCountryList();
    
    return countries.find(c => c.code === code) || {} as Country;
}